import React, { useEffect, useState } from 'react';
import EcomCartItem from '../../EcomTheme/EcomCartItem';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
const EcomChatModal = (props: any) => {
	// const [selectedProduct, setSelectedProduct] = useState(null);

	const [styleAdvisor, setStyleAdvisor] = useState<any>();
	const [styleAdvisorLoader, setStyleAdvisorLoader] = useState(false);

	const storeStyle = () => {
		if (styleAdvisor && styleAdvisor.length > 0)
			props.setStyleAdvisorCache([
				...props.styleAdvisorCache,
				{ id: loadStateSession('FF-productID'), data: styleAdvisor },
			]);
	};

	const handleStyleAdvisor = (product_id, product_name) => {
		if (props.enableStyleAdvisor === 'true') {
			setStyleAdvisor('');
			setStyleAdvisorLoader(true);
			Axios.post(
				window['BASE_URL'] + `/conversation/style_advisor`,
				{
					product_id: [product_id],
					botId: props.botId,
					version: 'prod',
					id: props.responseId,
					messageId: props.messageId,
					message: props.userQuery,
				},
				{
					headers: {
						'x-tenant-id': props.tenantId.toString(),
						'Authorization': `Bearer ${loadStateSession('token')}`,
					},
				}
			)
				.then((response) => {
					setStyleAdvisorLoader(false);

					const resp = response.data.style_advisor_products;
					//	getStyleAdvisor(resp, product_id);
					// setComplimentaryProducts(resp)
					setStyleAdvisor(resp);
					// let filteredStyle;
					// if (resp && resp.length) {
					// 	filteredStyle = resp.filter(
					// 		(product) => !props.productIds.includes(product.productId)
					// 	);
					// }
					// resp &&
					// 	resp.length &&
					// 	setStyleAdvisor((styleAdvisor) => [...styleAdvisor, ...filteredStyle]);

					//	getStyleAdvisor(resp, product_id);
					// setComplimentaryProducts(resp)
					// console.log('fil', filteredStyle, 'res', resp);
				})
				.catch((err) => {
					setStyleAdvisorLoader(false);
				});
		}
	};
	// const filterProduct = (products) => {

	// 	const filteredProducts = products.filter(product => !props.productIds.includes(product.productId));
	// 	return filteredProducts
	// }
	// const getStyleAdvisor = (resp, product_id) => {
	// 	// let data = { data: styleAdvisor, id: product_id };
	// 	let length = resp.complimentary_products.length - 1;

	// 	Axios.post(window['BASE_URL'] + `/search/semantic`, {
	// 		input_text: '',
	// 		tenant_id: props.tenantId.toString(),
	// 		bot_id: props.botId,
	// 		version: 'prod',
	// 		generic_response: '',
	// 		product_intent: '',
	// 		queries: resp.complimentary_products,
	// 		source: 'webs',
	// 		conversationId: props.conversationId,
	// 		messageId: props.messageId
	// 	}).then((resp) => {
	// 		resp.data.similar_content.length &&
	// 			setStyleAdvisor((styleAdvisor) => [
	// 				...styleAdvisor,
	// 				filterProduct(resp.data.similar_content),
	// 			]);
	// 	});
	// };

	return (
		<>
			<EcomCartItem
				staticDetailsURL={props.staticDetailsURL}
				reasonData={props.reasonData}
				reasonQuestion={props.reasonQuery}
				ecom={<></>}
				selectedProductID={props.selectedProductID}
				category={props.category}
				styleAdvisorCache={props.styleAdvisorCache}
				styleAdvisor={styleAdvisor}
				handleStyleAdvisor={handleStyleAdvisor}
				getTitleMessage={(data) => { }}
				setSelectedProductData={(data) => {
					props.handleSelectedProduct(data);
				}}
				tenantId={props.tenantId}
				token={props.token}
				conversationId={props.responseId}
				onClickStyleAdvisor={(product) => {
					storeStyle();
					setTimeout(() => {
						props.setCategory('You may also like');
						props.styleSelection(product);
					}, 100);
				}}
				onClose={() => {
					props.onClose(), storeStyle();
				}}
				products={''}
				theme={'E-commerce Chat'}
				modalClassName='ff-ecom-monaco'
				enableStyleAdvisor={props.enableStyleAdvisor}
				advisorTitle={props.advisorTitle}
				styleAdvisorLoader={styleAdvisorLoader}
			/>
		</>
	);
};

export default EcomChatModal;
